import type { ProgramCodeBook } from "../../../models/Program";
import type { ProgramRequestData } from "../../../models/ProgramRequest";

export const buildMinisterReadonlyRequestPatch = (
  ministerDetail: NonNullable<ProgramCodeBook["ministerDetail"]>,
): Partial<ProgramRequestData> => ({
  guidedLearningDuration: ministerDetail.guidedLearningDuration,
  independentLearningDuration: ministerDetail.independentLearningDuration,
  workLearningDuration: ministerDetail.workLearningDuration,
  formOfTeachingIds: ministerDetail.formOfTeachingIds,
  otherFormsOfTeaching: ministerDetail.otherFormsOfTeaching,
  enrollmentConditionsIds: ministerDetail.enrollmentConditionIds,
  otherEnrollmentConditions: ministerDetail.otherEnrollmentConditions,
  knowledgeChecksIds: ministerDetail.knowledgeCheckIds,
  otherKnowledgeChecks: ministerDetail.otherKnowledgeChecks,
  competences: ministerDetail.competences.map((name) => ({ name })),
  modules: ministerDetail.modules,
});

